import {HTMLAttributes} from 'react';
import {twMerge} from '../../../common/twMerge';
import {BadgeType} from '../../../graphql/generated/types';
import {LOG_CLICK_EVENT} from '../../../logging/logEvent';
import {BADGE_TYPE_TO_ICON_TYPE_MAP} from '../../atoms/Icon/constants';
import {Icon} from '../../atoms/Icon/Icon';
import {Image} from '../../atoms/Image/Image';
import {ThumbnailRatio} from '../../molecules/ThumbnailWithBadges/ThumbnailRatio.constant';
import {ThumbnailType} from '../../molecules/ThumbnailWithBadges/ThumbnailType.enum';
import {
  ContentOverviewThumbnailBadge,
  ContentOverviewThumbnailBadgeProps,
} from '../ContentOverviewThumbnailBadge/ContentOverviewThumbnailBadge';

export interface ContentOverviewThumbnailProps
  extends HTMLAttributes<HTMLDivElement> {
  src: string;
  alt?: string;
  metaBadge?: BadgeType;
  isMobile: boolean;
  onClickThumbnail: () => void;

  // badge 용도
  badgeProps?: ContentOverviewThumbnailBadgeProps;
}

export function ContentOverviewThumbnail({
  src,
  alt,
  isMobile,
  metaBadge,
  onClickThumbnail,
  className,
  badgeProps,
  ...props
}: ContentOverviewThumbnailProps) {
  return (
    <div
      className={twMerge(
        'mx-auto',
        !isMobile && 'w-160pxr',
        isMobile &&
          'w-[192px] under-mobile:w-[128px] under-375-view:w-[144px] under-390-view:w-[150px] under-490-view:w-[156px] under-640-view:w-[144px]',
        className
      )}
      {...props}
    >
      <div
        className="relative overflow-hidden rounded-8pxr"
        onClick={e => LOG_CLICK_EVENT('작품썸네일_클릭', e, onClickThumbnail)}
      >
        {badgeProps && (
          <ContentOverviewThumbnailBadge
            {...badgeProps}
            className="absolute left-4px top-4px z-10"
          />
        )}
        <Image
          src={src}
          ratio={ThumbnailRatio[ThumbnailType.Poster2To3]}
          alt={alt || '썸네일'}
        />
        {metaBadge && (
          <Icon
            type={BADGE_TYPE_TO_ICON_TYPE_MAP[metaBadge]}
            className="absolute left-4pxr top-4pxr h-16pxr"
            disableActiveEffect
          />
        )}
      </div>
    </div>
  );
}
